import { render } from "./EventList.vue?vue&type=template&id=ca793dd0&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ca793dd0&scoped=true&lang=css"

import exportComponent from "/Users/alain/Documents/realWorldVue/real-world-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca793dd0"]])

export default __exports__